import { useState } from "react";
import { useQuery } from "react-query";
import { useLogs } from "./useLogs";
import { LogsCronIProps } from "../model/schema";

export const useGetLogsCron = () => {
  const [params, setParams] = useState<LogsCronIProps | null>();
  const { getLogsCron } = useLogs();

  const getCronParams = (params: LogsCronIProps) => {
    setParams(params);
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ["getLogsCron", JSON.stringify(params)],
    queryFn: () => getLogsCron(params!),
    enabled: !!params,
  });
  return { data: data?.data, isLoading, isError, getCronParams };
};
